<template>

  <div>
      <!--<Banner></Banner>-->
    <product-detail-component v-if="showProduct" :product="selectedProduct" :goBack="goBackFromProduct" />
    <section class="products" :class="{ hide: showProduct }">

      <div class="container-fluid">
        <div class="search-container">
          <div class="search-wrapper">
            <input
              type="text"
              class="search-input"
              v-model="productSearch"
              placeholder="Buscar productos..."
              aria-label="Buscar productos"
            >
            <button class="search-button" type="button">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>

        <div class="row">
          <template v-if="!isLoading || products.length > 0">
            <div class="col-lg-3 col-sm-6 col-xs-12" v-for="product in products" :key="product.id" v-if="products.length>0">
              <product-box :product="product" :onProductClick="onProductClick"></product-box>
            </div>
          </template>
          <template v-if="isLoading">
            <div class="col-lg-3 col-sm-6 col-xs-12" v-for="n in 8" :key="n">
              <div class="product-skeleton">
                <div class="skeleton-image"></div>
                <div class="skeleton-content">
                  <div class="skeleton-title"></div>
                  <div class="skeleton-text"></div>
                  <div class="skeleton-price"></div>
                </div>
              </div>
            </div>
          </template>

          <infinite-loading ref="infiniteLoading" @infinite="infiniteScrollRest"  :identifier="infiniteId" spinner="waveDots">

            <div slot="no-more"></div>
            <div slot="no-results" v-if="!isLoading && products.length === 0 && lastSearch.length > 0">
              <div class="no-results-container">
                <div class="no-results-icon">
                  <i class="fas fa-search"></i>
                </div>
                <h3>No se encontraron productos</h3>
                <p>No encontramos productos que coincidan con tu búsqueda "{{ lastSearch }}"</p>
                <div class="suggestions">
                  <p>Sugerencias:</p>
                  <ul>
                    <li>Verifica que las palabras estén escritas correctamente</li>
                    <li>Intenta con términos más generales</li>
                    <li>Prueba con otras categorías</li>
                  </ul>
                </div>
              </div>
            </div>

          </infinite-loading>

          <div v-if="products.length<=0">
           <!-- <p>No hay productos destacados</p> -->
          </div>

        </div>
      </div>
    </section>



  </div>

</template>

<script>

import ProductBox from "@/components/ProductBox";
import Api from '@/Api'
import axios from 'axios'
import {baseUrl} from "../Api";
import ProductDetailComponent from './ProductDetailComponent.vue';

// Simple debounce utility
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

export default {
  components: {ProductBox, ProductDetailComponent},
  data () {
    return {
      products:[],
      showProduct:false,
      selectedProduct:null,
      currentPage:1,
      infiniteId: +new Date(),
      totalPage:0,
      trigger: 300,
      totalItems:0,
      productSearch:'',
      cancelToken:undefined,
      actualOffset:0,
      isLoading: false,
      lastSearch: '', // track last search for no-results
      searchRequestId: 0, // track latest search request
      debouncedHandleSearch: null, // robust debounce
    }
  },

  created() {
    this.debouncedHandleSearch = debounce(this.handleSearch, 300);
  },

  watch:{
    productSearch: function() {
      this.debouncedHandleSearch();
    }
  },
  methods:{
    handleSearch() {

      // Cancel any ongoing request
      if (this.cancelToken) {

        this.cancelToken.cancel("Operation canceled due to new search.");
      }
      this.products = [];
      this.currentPage = 1;
      this.lastSearch = this.productSearch;
      this.searchRequestId += 1;
      // Change infiniteId to force re-mount
      this.infiniteId++;
      this.$nextTick(() => {
        this.$refs.infiniteLoading.stateChanger.complete();

        if (this.$refs.infiniteLoading) {
          this.$refs.infiniteLoading.stateChanger.reset();
          this.infiniteScrollRest(this.$refs.infiniteLoading.stateChanger);
        }
      });
    },
    goBackFromProduct(){
      this.showProduct = false;
       this.$nextTick(() => {
        window.scrollTo(0,this.actualOffset);
      });

    },
    onProductClick(product){
      this.actualOffset = window.pageYOffset;
      this.showProduct = true;
      this.selectedProduct = product;
      $('.productoCarousel').carousel({ride:true});
      window.scrollTo(0,0);
    },
    infiniteScrollRest ($state) {
      this.isLoading = true;
      if (this.cancelToken) {
        this.cancelToken.cancel("Operation canceled due to new request.")
      }
      // Save the cancel token for the current request
      this.cancelToken = axios.CancelToken.source();
      const currentRequestId = this.searchRequestId;
      this.isLoading = true;
      Api().get('products?search=' + this.productSearch + '&sort_by=COD_ARTICU&per_page=10&page=' + this.currentPage, { cancelToken: this.cancelToken.token }).then(data=>{
        // Only process if this is the latest request
        if (currentRequestId !== this.searchRequestId) {
          return;
        }
        const products = data.data.data;
        this.isLoading = false;

        if (products.data.length === 0 && this.currentPage === 1) {
          $state.complete();
          $state.noResults();
          return;
        }

        products.data.forEach(value => {
          this.products.push(value);
        });

        if (parseInt(products.total)>0) {
          if ((this.currentPage*10)===(parseInt(products.total))){
            $state.complete();
          }else{
            this.currentPage = this.currentPage + 1;
            if (products.data.length>0)
            {
              $state.loaded();
            }else{
              $state.complete();
            }
          }
        }else{
          $state.complete();
        }
      }).catch(err=>{
        // Only process if this is the latest request
        if (currentRequestId !== this.searchRequestId) {
          return;
        }
        this.isLoading = false;
        // Only complete the state if this is not a cancelation
        if (!axios.isCancel(err)) {
          $state.complete();
        }
      });
    },

  },
  mounted(){
    $('body').removeClass();
  }
}
</script>

<!-- Add "thisd" attribute to limit CSS to this component only -->
<style scoped>
.hide {
    visibility: hidden !important;
}

.search-container {
    margin-bottom: 2em;
    display: flex;
    justify-content: center;
}

.search-wrapper {
    max-width: 400px;
    width: 100%;
    display: flex;
    position: relative;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border-radius: 4px;
}

.search-input {
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    padding: 1rem 1.5rem;
    font-size: 1.2rem;
    transition: border-color 0.15s ease-in-out;
    border-right: none;
    height: 56px;
}

.search-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.search-button {
    border-radius: 0 4px 4px 0;
    padding: 0 1.5rem;
    background-color: #DB5378;
    border: none;
    color: white;
    transition: background-color 0.15s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 56px;
    font-size: 1.2rem;
}

.search-button:hover {
    background-color: #c44a6a;
}

.product-skeleton {
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
}

.skeleton-image {
    background: #f0f0f0;
    height: 200px;
    border-radius: 4px;
    margin-bottom: 15px;
    animation: pulse 1.5s infinite;
}

.skeleton-content {
    padding: 10px 0;
}

.skeleton-title {
    background: #f0f0f0;
    height: 20px;
    width: 80%;
    margin-bottom: 10px;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
}

.skeleton-text {
    background: #f0f0f0;
    height: 15px;
    width: 60%;
    margin-bottom: 10px;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
}

.skeleton-price {
    background: #f0f0f0;
    height: 25px;
    width: 40%;
    border-radius: 4px;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}

.no-results-container {
  text-align: center;
  padding: 3rem 1rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin: 2rem auto;
  max-width: 600px;
}

.no-results-icon {
  font-size: 3rem;
  color: #DB5378;
  margin-bottom: 1rem;
}

.no-results-container h3 {
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.no-results-container p {
  color: #666;
  margin-bottom: 1.5rem;
}

.suggestions {
  text-align: left;
  max-width: 400px;
  margin: 0 auto;
}

.suggestions p {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.suggestions ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.suggestions li {
  color: #666;
  padding: 0.5rem 0;
  position: relative;
  padding-left: 1.5rem;
}

.suggestions li:before {
  content: "•";
  color: #DB5378;
  position: absolute;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue